export default __webpack_public_path__ + "static/media/femimed_aparat_usg.64719e39.webp";